/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import callBackurl from '@/components/callBackurl'
import todoPage from '@/components/todoPage/todoPage'
import v2todoPage from '@/components/v2todoPage/v2todoPage'
import leaveList from '@/components/leaveList/leaveList'
import schoollist from '@/components/schoolList/schoollist'
import actvDetail from '@/components/actvDetail/actvDetail'
import dataCenter from '@/components/dataCenter/dataCenter'
import dataReport from '@/components/dataReport/dataReport'
import dataDetailReport from '@/components/dataReport/dataDetailReport'
import reportList from '@/components/reportList/reportList'
import dataDetail from '@/components/dataDetail/dataDetail'
import handleReport from '@/components/handleReport/handleReport'
import handleReply from '@/components/handleReply/handleReply'
import handleRecord from '@/components/handleRecord/handleRecord'
import bindLogin from '@/components/bindLogin/bindLogin'
import error404 from '@/components/errorPage/404'
import errorusewechat from '@/components/errorPage/notWechat'
import noauth from '@/components/errorPage/noAuth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/h5/',
  routes: [
    {
      path: '/bindLogin',
      name: 'bindLogin',
      component: bindLogin
    },{
      path: '*',
      component: error404
    },
    {
      path: '/callbackurl',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/v2callbackurl',
      name: 'callBackurl',
      component: callBackurl
    },
    {
      path: '/todoPage',
      name: 'todoPage',
      component: todoPage
    },
    {
      path: '/v2todoPage',
      name: 'v2todoPage',
      component: v2todoPage
    },
    {
      path: '/leaveList',
      name: 'leaveList',
      component: leaveList
    },
    {
      path: '/schoollist',
      name: 'schoollist',
      component: schoollist
    },
    {
      path: '/actvDetail',
      name: 'actvDetail',
      component: actvDetail
    },
    {
      path: '/dataCenter',
      name: 'dataCenter',
      component: dataCenter
    },
    {
      path: '/dataDetail',
      name: 'dataDetail',
      component: dataDetail
    },
    {
      path: '/reportList',
      name: 'reportList',
      component: reportList,
      meta: {
        require: true
      }
    },
    {
      path: '/dataReport',
      name: 'dataReport',
      component: dataReport,
      meta: {
        require: true
      }
    },
    {
      path: '/dataDetailReport',
      name: 'dataDetailReport',
      component: dataDetailReport,
      meta: {
        require: true
      }
    },
    {
      path: '/handleReport',
      name: 'handleReport',
      component: handleReport
    },
    {
      path: '/handleReply',
      name: 'handleReply',
      component: handleReply
    },
    {
      path: '/handleRecord',
      name: 'handleRecord',
      component: handleRecord
    },
    {
      path: '/errorusewechat',
      name: 'errorusewechat',
      component: errorusewechat,
      meta: {
        require: true
      }
    },
    {
      path: '/noauth',
      name: 'noauth',
      component: noauth
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => !res.meta.require)) {
    if (!isWeiXin()) {
      next({
        path: '/errorusewechat'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase()
  return true
  // if (ua.indexOf('micromessenger') !== -1) {
  //   return true
  // } else {
  //   return false
  // }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js